import React, { useRef, useState } from 'react';
import { FaChevronRight } from "react-icons/fa";
import { IoIosAdd } from "react-icons/io";
import { IoChevronDownSharp } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import { baseUrl } from '../config';



const MarketingColumn = ({ column, campaigns, onAddCampaign, onUpdateCampaign, onDropCampaign }) => {
  const [dropdownVisible, setDropdownVisible] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newCampaign, setNewCampaign] = useState({
    title: '',
    description: '',
    dueDate: '',
    progress: 0,
    assignedTo: '',
    column: column,
  });
  const [draggingIndex, setDraggingIndex] = useState(null);
  const progressRef = useRef({});

  const handleDragStart = (e, campaignIndex) => {
    e.dataTransfer.setData('campaignIndex', campaignIndex);
    e.dataTransfer.setData('fromColumn', column);
  };

  const handleDrop = (e) => {
    const campaignIndex = e.dataTransfer.getData('campaignIndex');
    const fromColumn = e.dataTransfer.getData('fromColumn');

    if (fromColumn !== column) {
      onDropCampaign(campaignIndex, fromColumn, column);
    }
    e.preventDefault();
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleColumnChange = (campaignIndex, newColumn) => {
    const updatedCampaign = { ...campaigns[campaignIndex], column: newColumn };
    onUpdateCampaign(campaignIndex, updatedCampaign);
    setDropdownVisible({});
  };

  const toggleDropdown = (index) => {
    setDropdownVisible((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setNewCampaign((prevCampaign) => ({
      ...prevCampaign,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing && onUpdateCampaign) {
      onUpdateCampaign(editIndex, newCampaign);
    } else if (onAddCampaign && newCampaign.title && newCampaign.description) {
      onAddCampaign(newCampaign);
    }
    setNewCampaign({
      title: '',
      description: '',
      dueDate: '',
      progress: 0,
      assignedTo: '',
      column: column,
    });
    setShowForm(false);
    setIsEditing(false);
    setEditIndex(null);
  };

  const handleEditCampaign = (campaign, originalIndex) => {
    setIsEditing(true);
    setEditIndex(originalIndex); 
    setNewCampaign(campaign);
    setShowForm(true);
  };

  return (
    <div className="bg-white p-4 rounded-lg w-25 h-full mx-2 shadow-sm" onDragOver={handleDragOver} onDrop={handleDrop}>
      <div className='flex justify-between h-10 border-b border-gray-400'>
        <div className='flex'>
          <div className={`w-3 h-3 rounded-full mr-2 ${column === 'Planning' ? 'bg-green-500' : column === 'Content Creation' ? 'bg-blue-600' : column === 'Ad Setup' ? 'bg-yellow-600' : column === 'Live Campaign' ? 'bg-purple-600' : 'bg-red-600'}`}></div>
          <p className="text-left">{column}</p>
        </div>
        <div className='flex'>
          <IoIosAdd className="text-xl mx-1 cursor-pointer" onClick={() => setShowForm(true)} />
          <FaChevronRight className="text-sm" />
        </div>
      </div>
      {showForm && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-md p-5 w-full max-w-md mx-auto relative">
            <button onClick={() => setShowForm(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-700">&times;</button>
            <form onSubmit={handleSubmit}>
              <input type="text" name="title" value={newCampaign.title} onChange={handleFormChange} placeholder="Campaign Title" required className="w-full p-2 mb-2 border border-gray-300 rounded-lg" />
              <textarea name="description" value={newCampaign.description} onChange={handleFormChange} placeholder="Campaign Description" required className="w-full p-2 mb-2 border border-gray-300 rounded-lg h-24 resize-none" />
              <input type="date" name="dueDate" value={newCampaign.dueDate} onChange={handleFormChange} className="w-full p-2 mb-2 border border-gray-300 rounded-lg" />
              <input type="number" name="progress" value={newCampaign.progress} onChange={handleFormChange} placeholder="Progress (%)" min="0" max="100" className="w-full p-2 mb-2 border border-gray-300 rounded-lg" />
              <input type="text" name="assignedTo" value={newCampaign.assignedTo} onChange={handleFormChange} placeholder="Assigned To" className="w-full p-2 mb-4 border border-gray-300 rounded-lg" />
              <div className="flex justify-end gap-2">
                <button type="submit" className="bg-blue-600 text-white p-2 rounded-lg hover:bg-blue-600 transition">{isEditing ? 'Update Campaign' : 'Add Campaign'}</button>
                <button type="button" onClick={() => setShowForm(false)} className="bg-gray-500 text-white p-2 rounded-lg hover:bg-gray-600 transition mr-2">Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {campaigns && campaigns.length > 0 ? (
        campaigns.map((campaign, index) => (
          <div key={index} className="bg-white p-4 mt-2 rounded-lg shadow-sm relative" draggable onDragStart={(e) => handleDragStart(e, index)}>
            <div className="flex justify-between items-center mb-2">
              <h6 className="font-medium">{campaign.title}</h6>
              <div className="flex items-center">
                <IoChevronDownSharp className="text-lg cursor-pointer" onClick={() => toggleDropdown(index)} />
                <MdEdit className="text-xl mx-1 cursor-pointer" onClick={() => handleEditCampaign(campaign, index)} />
              </div>
            </div>
            {dropdownVisible[index] && (
              <div className="bg-gray-100 border border-gray-200 rounded-lg p-2 mt-1 shadow-lg z-50 absolute right-0 top-full mt-1" onClick={(e) => e.stopPropagation()}>
                <ul className="list-none m-0 p-1">
                  {['Planning', 'Content Creation', 'Ad Setup', 'Live Campaign', 'Completed'].map((status) => (
                    <li key={status} className="cursor-pointer p-2 border-b border-gray-300 hover:bg-gray-200" onClick={() => handleColumnChange(index, status)}>{status}</li>
                  ))}
                </ul>
              </div>
            )}
            <p className="mt-2">{campaign.description}</p>
            <p className="text-sm text-gray-600">Due date: {campaign.dueDate}</p>
            <p className="text-sm text-gray-600">% progress: {campaign.progress}%</p>
            <div className="w-full h-5 bg-gray-200 rounded-lg overflow-hidden mt-2" ref={(el) => progressRef.current[index] = el}>
              <div className="bg-purple-600 h-full flex items-center justify-center text-xs text-white rounded-lg" style={{ width: `${campaign.progress}%` }}>{campaign.progress}%</div>
            </div>
          </div>
        ))
      ) : (
        <p>No campaigns available</p>
      )}
    </div>
  );
};

export default MarketingColumn;

